/**
 * Preload image URLs into the browser cache before entrance animations.
 * Resolves even if some images fail so animations are never blocked forever.
 */
export const preloadImages = (urls = [], { timeoutMs = 2500 } = {}) => {
  const uniqueUrls = [...new Set(urls.filter(Boolean))];
  if (!uniqueUrls.length || typeof window === 'undefined') {
    return Promise.resolve();
  }

  const loadOne = (src) =>
    new Promise((resolve) => {
      const img = new window.Image();
      const done = () => resolve();
      img.onload = done;
      img.onerror = done;
      img.src = src;
      if (img.complete) done();
    });

  return Promise.race([
    Promise.all(uniqueUrls.map(loadOne)),
    new Promise((resolve) => setTimeout(resolve, timeoutMs)),
  ]);
};
